import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
//----- store
// import { fetchPageData, submitRating } from "../store/CourseDetails-actions";
import { fetchPageData, submitRating } from "../store/CourseCompletedDetails-actions";

import TableGeralDataWithQrCode from "../components/TableGeralDataWithQRCode/TableGeralDataWithQRCode";
import FormOpinion from "../components/FormOpinion/FormOpinion";

import HeaderBreadCrumb from "../components/HeaderBreadCrumb/HeaderBreadCrumb";
import BoxTitle from "../components/BoxTitle/BoxTitle";
import IconTitle from "../components/IconTitle/IconTitle";
import Box from "@material-ui/core/Box";

import Styles from "./CourseCompletedDetails.module.css";

const CourseCompletedDetails = () => {
	const dispatch = useDispatch();
	const [courseDetailsDataLoaded, setCourseDetailsData] = useState(false);
	const params = useParams();
	const history = useHistory();

	// const CourseDetailsData = useSelector((state) => state.CourseDetailsData);
	const CourseDetailsData = useSelector((state) => state.CourseCompletedDetailsData);

	const apiConfigData = useSelector((state) => state.apiConfigData);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	let url_data;

	if (params.trainingType === "Program") {
		url_data =
			apiConfigData.endpoint.domain +
			apiConfigData.endpoint.courseCompletionDetails +
			"/Program/" +
			params.courseId;
	}

	if (params.trainingType === "Class") {
		url_data =
			apiConfigData.endpoint.domain +
			apiConfigData.endpoint.courseCompletionDetails +
			"/Course/" +
			params.courseId;
	}

	// console.log("params", params);
	console.log("url_data", url_data);

	const returnClickHandler = () => {
		history.goBack();
	};

	const formOpinionSubmitHandler = (formData) => {
		// console.log("formOpinionSubmitHandler", formData);

		const formOpinionSubmitURL = url_data + "/Evaluate";
		// console.log("formOpinionSubmitURL", url_data + "/Evaluate");

		// console.log(CourseDetailsData)

		const refactoredFormData = {
			"trainingId": CourseDetailsData.pageData.id,
			"enrollmentId": CourseDetailsData.pageData.enrollmentId,
			"ratingEval": Number(formData.stars) > 0 ? formData.stars : 0,
			"commentEval": formData.opinion,
		}

		console.log("Rating Opinion", refactoredFormData)
		// console.log("autenticationData", autenticationData)

		dispatch(submitRating(formOpinionSubmitURL, refactoredFormData, autenticationData));
	};

	useEffect(() => {
		dispatch(fetchPageData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		if (CourseDetailsData.pageData.modality.id !== "") {
			console.log("CourseDetailsData", CourseDetailsData);
			setCourseDetailsData(true);
		}
	}, [CourseDetailsData]);

	return (
		<div
			className={Styles["courseCompletedDetails"]}
			style={{ color: "#ededed" }}
		>
			{courseDetailsDataLoaded && (
				<div className={`container ${Styles["container"]}`}>
					<div className={"row"}>
						{/* <div className={"col-xs-12 title"}>
						<HeaderBreadCrumb />
					</div> */}
						<IconTitle
							title={CourseDetailsData.pageData.name}
							onClick={returnClickHandler}
						/>
					</div>
					<div className={"row"}>
						<div className={"col-xs-12"}>
							<div className={"row"}>
								<div
									className={`col-xs-12 ${Styles["col-padding"]}`}
								>
									<Box
										component="div"
										className={"box-container"}
									>
										<TableGeralDataWithQrCode
											TableGeralDataWithQrCodeData={
												CourseDetailsData
											}
										/>
									</Box>
								</div>
							</div>
							<div className={"row"}>
								<div
									className={`col-xs-12 ${Styles["col-padding"]}`}
								>
									<Box
										component="div"
										className={"box-container"}
									>
										<BoxTitle title="Dê a sua opinião sobre esta acção de formação!" />
										<FormOpinion
											data={CourseDetailsData}
											formOpinionSubmit={
												formOpinionSubmitHandler
											}
										/>
									</Box>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default CourseCompletedDetails;
